/* ════════════════════════════════════════════════════════════════
   KORAÏ CARD HOVER — Universal Quick-Add Handler
   Handles: hover states, add-to-cart, size/color variant selection,
            mobile + button, toast notifications
   ════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── 1. HOVER MANAGER (event delegation — works with dynamic cards) ── */
  document.addEventListener('mouseover', function (e) {
    const card = e.target.closest('.korai-card-wrapper');
    if (card) card.classList.add('eq-hovered');
  });

  document.addEventListener('mouseout', function (e) {
    const card = e.target.closest('.korai-card-wrapper');
    if (card && !card.contains(e.relatedTarget)) {
      card.classList.remove('eq-hovered');
    }
  });

  /* ── 2. ADD TO CART ── */
  async function addToCart(variantId, btn) {
    if (!variantId) return;

    const originalHtml = btn ? btn.innerHTML : '';
    if (btn) {
      btn.innerHTML = '<span style="opacity:0.5">…</span>';
      btn.style.pointerEvents = 'none';
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Cart error');
      }

      /* Update Shopify cart bubble */
      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
        if (bubble) bubble.textContent = cart.item_count;
        /* Trigger Shopify cart drawer if theme supports it */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (_) {}

      showToast('Added to bag');

    } catch (err) {
      console.error('[korai-card-hover] addToCart:', err.message);
      showToast(err.message === 'Cart error' ? 'Something went wrong' : err.message, true);
    } finally {
      if (btn) {
        btn.innerHTML = originalHtml;
        btn.style.pointerEvents = '';
      }
    }
  }

  /* ── 3. CLICK DELEGATION ── */
  document.addEventListener('click', async function (e) {

    /* 3a. "Add to bag" button — single variant OR color_size_simple final step */
    const atbBtn = e.target.closest('.eq-btn[data-action="atb"]');
    if (atbBtn && !atbBtn.classList.contains('eq-btn--soldout')) {
      e.preventDefault();
      e.stopPropagation();
      await addToCart(atbBtn.dataset.variantId, atbBtn);
      return;
    }

    /* 3b. Size chip — size_only case (click = immediate add) */
    const sizeChip = e.target.closest('.eq-sizes:not(.eq-sizes--cs) .eq-chip:not(.eq-chip--out)');
    if (sizeChip && sizeChip.dataset.action === 'atb') {
      e.preventDefault();
      e.stopPropagation();
      await addToCart(sizeChip.dataset.variantId, sizeChip);
      return;
    }

    /* 3c. Size chip — color_size_simple case (click = select size, reveal atb) */
    const csChip = e.target.closest('.eq-sizes--cs .eq-chip:not(.eq-chip--out):not(.eq-chip--hidden)');
    if (csChip) {
      e.preventDefault();
      e.stopPropagation();
      const wrap = csChip.closest('.eq-wrap');
      if (!wrap) return;

      /* Mark chip active */
      wrap.querySelectorAll('.eq-sizes--cs .eq-chip').forEach(c => c.classList.remove('eq-chip--active'));
      csChip.classList.add('eq-chip--active');

      /* Show Add to bag button with variant id */
      const atb = wrap.querySelector('.eq-btn--atb');
      if (atb) {
        atb.dataset.variantId = csChip.dataset.variantId;
        atb.classList.remove('eq-btn--hidden');
      }
      return;
    }

    /* 3d. Color swatch — color_size_simple case */
    const csSwatch = e.target.closest('.eq-swatch--cs');
    if (csSwatch) {
      e.preventDefault();
      e.stopPropagation();
      const wrap = csSwatch.closest('.eq-wrap');
      if (!wrap) return;
      const selectedColor = csSwatch.dataset.color;

      /* Update active swatch */
      wrap.querySelectorAll('.eq-swatch--cs').forEach(s => s.classList.remove('eq-swatch--active'));
      csSwatch.classList.add('eq-swatch--active');

      /* Show only chips matching this color */
      wrap.querySelectorAll('.eq-sizes--cs .eq-chip').forEach(chip => {
        if (chip.dataset.color === selectedColor) {
          chip.classList.remove('eq-chip--hidden');
        } else {
          chip.classList.add('eq-chip--hidden');
          chip.classList.remove('eq-chip--active');
        }
      });

      /* Reset "Add to bag" until a size is chosen */
      const atb = wrap.querySelector('.eq-btn--atb');
      if (atb) {
        atb.dataset.variantId = '';
        atb.classList.add('eq-btn--hidden');
      }
      return;
    }

    /* 3e. Arrow scroll for size chips */
    const arrow = e.target.closest('.eq-arrow');
    if (arrow) {
      e.preventDefault();
      e.stopPropagation();
      const track = arrow.closest('.eq-sizes')?.querySelector('.eq-sizes__track-wrap');
      if (track) {
        track.scrollBy({
          left: arrow.classList.contains('eq-arrow--next') ? 80 : -80,
          behavior: 'smooth'
        });
      }
      return;
    }

    /* 3f. Mobile + button */
    const mobileBtn = e.target.closest('.eq-mobile-btn');
    if (mobileBtn) {
      e.preventDefault();
      e.stopPropagation();
      const qaCase = mobileBtn.dataset.qaCase;
      const variantId = mobileBtn.dataset.variantId;
      const productUrl = mobileBtn.dataset.productUrl;

      if (qaCase === 'single' && variantId) {
        await addToCart(variantId, mobileBtn);
      } else if (productUrl) {
        window.location.href = productUrl;
      }
      return;
    }

  });

  /* ── 4. TOAST ── */
  function showToast(message, isError) {
    let toast = document.getElementById('korai-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'korai-toast';
      toast.innerHTML = '<span class="toast__dot"></span><span class="toast__msg"></span>';
      document.body.appendChild(toast);
    }

    const dot = toast.querySelector('.toast__dot');
    const msg = toast.querySelector('.toast__msg');
    if (dot) dot.style.background = isError ? '#e07b7b' : '#7bb87b';
    if (msg) msg.textContent = message;

    toast.classList.add('visible');
    clearTimeout(toast._hideTimeout);
    toast._hideTimeout = setTimeout(() => toast.classList.remove('visible'), 2500);
  }

})();
